import {BrowserRouter, Route, Routes} from "react-router";
import {OverviewPage} from "@/pages/overview/over-view";
import Layout from "@/layout/layout";
import LoginPage from "@/pages/auth/LoginPage";
import RegisterPage from "@/pages/auth/RegisterPage";
import { Provider } from 'react-redux'
import {store} from "@/store";
import {Extensions} from "@/pages/extensions";
import {Genaral} from "@/pages/plan-not-access/genaral.tsx";
import {SentryRoutes} from "@/instrument.ts";
import {SystemAccount} from "@/pages/system-account";
import FeatureRequestPage from "@/pages/feature-request";

function App() {

  return (
    <Provider store={store}>
        <BrowserRouter>
           <SentryRoutes>
               <Route errorElement={<YourCustomRootErrorBoundary />}>
                   <Route path="/login" element={<LoginPage />} />
                   <Route path="/register" element={<RegisterPage />} />
                   <Route element={<Layout/>}>
                       <Route index element={<OverviewPage />}/>
                       <Route path="extensions" element={<Extensions/>}/>
                       <Route path="system/account" element={<SystemAccount/>} />
                       <Route path="403" element={<Genaral/>}/>
                       <Route path="feature-request" element={<FeatureRequestPage/>}/>
                   </Route>
               </Route>
          </SentryRoutes>
        </BrowserRouter>
    </Provider>
  )
}

export default App


// error boundary
import { useRouteError } from "react-router";
import * as Sentry from "@sentry/react";
import {useEffect} from "react";
export function YourCustomRootErrorBoundary() {
    const error = useRouteError() as Error;
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);
    return (
        <div>
            <h1>אופס!</h1>
            <p>נראה שיש בעיה במערכת</p>
            <p>אנא נסה שוב מאוחר יותר</p>
        </div>
    );
}
